import React, { Component } from 'react';
import LookupItem from '../../../Domain/LookupItem';
import LookupService from '../../../Services/LookupService';
import LookupSearchParams from './LookupSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class LookupAdminPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new LookupSearchParams(),
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={LookupItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={LookupService.GetLookupItemList}
          convertDBItemsFunction={LookupService.ConvertDBItem}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          searchParamsType={LookupSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in id and name...'
          errorCode='LAP30'
        />
      </div>
    );
  }
}
